"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.polypup = void 0;
exports.polypup = {
    masterchef: "0xCc7E7c9FC775D25176e9Bfc5A400EdAc212aa81C",
};
